import React, { useState, useEffect, useRef } from "react";
import "../../assets/css/new-website.css"
import Footer from "../layout/footerUpdated";
import Header from "../layout/headerHome";
import SliderLab from "../element/component/Banner_slider";
import ServiceSection from "../element/component/ServiceSectionDentalGentle";
import FAQComponent from '../element/component/faq';
import WhyLab from '../element/component/why';
import TestimonialSlider from "../element/component/testimonial-slider";
import ReachToUsForm from "../element/ReachToUsForm";
import Popup_Main from "../element/component/Popup_Main";

const YogaPage = () => {

  const [isOpen, setIsOpen] = useState(false);
  const Counter = ({ targetValue, duration }) => {
    const [count, setCount] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);
  
    useEffect(() => {
      let startValue = 0;
      const increment = targetValue / (duration / 50);
  
      const updateCounter = () => {
        startValue += increment;
        if (startValue >= targetValue) {
          setCount(Math.ceil(targetValue));
          setIsAnimating(false); // End animation
        } else {
          setCount(Math.floor(startValue));
          setIsAnimating(true); // Start animation
          requestAnimationFrame(updateCounter);
        }
      };
  
      setIsAnimating(true); // Initialize animation
      updateCounter();
    }, [targetValue, duration]);
  
    return <h3 className={isAnimating ? "animate-counter" : ""}>{count}%</h3>;
  };

  const [activeIndex, setActiveIndex] = useState(0);
  
  const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
   };

  const cardsData = [
    { title: "Diabetes Nutrition", image: "/images/sugar-blood-test.webp", desc: "Personalised food strategies to support blood sugar management and healthier everyday eating." },
    { title: "Weight Management", image: "/images/new-website/yoga/obesity.webp" },
    { title: "Gut Health Nutrition", image: "/images/new-website/yoga/digestive-health.webp" },
    { title: "Heart Health & Cholesterol", image: "/images/new-website/yoga/healthy-heart.webp" },
    { title: "PCOS Nutrition", image: "/images/new-website/yoga/women-health.webp" },
    { title: "Pregnancy Nutrition", image: "/images/new-website/yoga/lifestyle-yoga.webp" },
  ];
  
  const whyData = [
    { title: "Nutrition Insights & Personalised Diet Plan", image: "/images/new-website/diet-nutrition/nutrition.webp" },
    { title: "AI enabled CGM supported program", image: "/images/new-website/diet-nutrition/artificial-intelligence.webp" },
    { title: "Professional, Highly experienced Dieticians", image: "/images/new-website/diet-nutrition/dietician.png" },
    { title: "For better Weight-Gain/Loss management program", image: "/images/new-website/diet-nutrition/weight-scale.webp" },
    { title: "Reduced Stress and Improved Sleep", image: "/images/new-website/diet-nutrition/stress-relief.webp" },
    { title: "Become a Healthier & Fitter You", image: "/images/new-website/diet-nutrition/slim-body.webp" },
];

const dietTypes = [
        {
            name: "Diabetes Nutrition",
            desc: "Personalised food strategies to support blood sugar management and healthier everyday eating.",
            image: "/images/new-website/physiotherapy/musculoskeletal-pain.webp",
          },
          {
            name: "Weight Management",
            desc: "Practical nutrition plans designed to support healthy and sustainable weight loss or weight gain.",
            image: "/images/new-website/physiotherapy/joint-replacement-surgery.webp",
          },
          {
            name: "Gut Health Nutrition",
            desc: "Nutrition guidance designed around digestive health, food tolerance and healthy eating patterns.",
            image: "/images/new-website/physiotherapy/sports-ankle-physio.webp",
          },
          {
            name: "Heart Health & Cholesterol",
            desc: "Heart-friendly nutrition strategies to support cholesterol, blood pressure and overall cardiovascular health.",
            image: "/images/new-website/physiotherapy/sports-ankle-physio.webp",
          },
          {
            name: "PCOS Nutrition",
            desc: "Personalised nutrition support for weight, metabolic health and everyday management of PCOS.",
            image: "/images/new-website/physiotherapy/post-paralysis-physio.webp",
          },
          {
            name: "Pregnancy Nutrition",
            desc: "Nutrition guidance to support changing nutritional needs through pregnancy and maternal well-being.",
            image: "/images/new-website/physiotherapy/women-pelvic-repair.webp",
          },
    
];

const options = [
    {
      title: "Personalised Nutrition Plans ",
      content: "Every plan is crafted to match your lifestyle and health goals, ensuring sustainable results."
    },
    {
      title: "Expert Online & Offline Guidance",
      content: "Access the best dietician in Bangalore for weight loss or consult an online dietician near you for 24/7 support."
    },
    {
      title: "Holistic Tech Aided Focus on Wellness ",
      content: "Our approach combines balanced nutrition with practical strategies, and advanced technology for long-term health success."
    },
  ];

  const testimonials = [
    {
      content:
        "Bridge health offers services at affordable cost. Akshata at the front desk is very cooperative and good at coordinating and follow-ups. The staff are well spoken and carried out all tests with patience.",
      name: "Akshata J Lokhande",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "I am Prof Sundararaj living at PRIMUS REFLECTION. The staff are very courteous with a smile on their faces, including all the doctors. Special thanks to Ms. Akshita!",
      name: "Sundar Raj",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "Good , clean hygiene place ... Feels like your are at home with the services that provide... I have enrolled for gym here.. And the trainers are thorough professionals.. And the staff I have interacted with them during the seminars or presentations they are knowledgeable",
      name: "Shiva Kumar S",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "From sattva apartment Bridge healthy is useful for our patients.Mahendra the nursing staff is good and courteous.",
      name: "Susheela Sharan",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
    {
      content:
        "Laxman is an excellent nurse looking after the retired community. Gentle in taking blood. Very polite and efficient.",
      name: "Dipak Rao",
      image: "/images/new-website/bridgehealth-icon-new.webp", // Replace with actual image URL
    },
  ];

  const faqs = [
    {
      question: "What is the best Diet for Weight Loss in Bangalore? ",
      answer:
        "A balanced diet with local, seasonal foods like millets, vegetables, lean proteins, and controlled portions can support sustainable weight loss. ",
    },
    {
      question: "How can I improve my Gut Health with Diet? ",
      answer: "Eat a fibre-rich diet including fruits, vegetables, whole grains, and fermented foods like yogurt or idli to promote healthy gut bacteria. ",
    },
    {
      question: "What is Personalised Nutrition and How It Works? ",
      answer: "Personalised nutrition tailors dietary recommendations based on individual factors like genetics, health goals, and lifestyle for better health outcomes. ",
    },
    {
      question: "Can I manage my Cholesterol through Diet? ",
      answer: "Yes, consuming foods rich in fibre, healthy fats (like nuts and fish), and avoiding trans fats can effectively lower cholesterol levels.",
    },
    {
      question: "What is the cost of a Diet Coach in Bangalore? ",
      answer: "The cost of a diet coach in Bangalore ranges from ₹1,500 to ₹5,000 per session, depending on the coach's experience and expertise. ",
    },
  ];


  const [isMobile, setIsMobile] = useState(false);
  const sectionRefs = useRef([]); // Refs for multiple sections/cards
  const [hasAnimated, setHasAnimated] = useState([]); // Animation tracking for cards

  // Resize event listener to detect mobile view
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // Initialize on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Scroll Animation Logic
  useEffect(() => {
    const handleScroll = () => {
      const updatedVisibility = sectionRefs.current.map((ref) => {
        if (ref) {
          const rect = ref.getBoundingClientRect();
          const windowHeight =
            window.innerHeight || document.documentElement.clientHeight;

          // Element becomes visible when its top is within viewport
          return rect.top <= windowHeight - 50;
        }
        return false;
      });

      setHasAnimated((prev) =>
        updatedVisibility.map((visible, index) => prev[index] || visible)
      );
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Trigger on mount to check initial visibility
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  return (
    <div>
      <Header/>
      <div className={`landingcontainer-physio ${isMobile ? "mobile" : ""}`}>
        <div className={`leftContainerNutrition ${isMobile ? "mobile" : ""}`}>
          <h1>
            <span className="highlight1">Personalised Nutrition</span> for Your Health Goals
          </h1>
          <p className="paragraph-left">Work with experienced dietitians to build practical, personalised nutrition plans for weight management, diabetes, gut health, PCOS, heart health, and everyday well-being.</p>
          <button className="buttonlanding" onClick={()=>setIsOpen(true)}>Book a Nutrition Consultation</button>
        </div>
        <div className="rightContainer">
          <img
            src="/images/new-website/diet-nutrition/nutritionist-banner.webp"
            alt="yoga-landing"
            className="imagelanding imageFadeInUp"
          />
        </div>
      </div>
      
            <section>
            <div className="rightstrongcontainer">
            <h2 className="heading1">
            What Can Our
              <span className="highlight1"> Nutritionist</span>
              <span className="line-break-heading"></span> Help You With?
            </h2>
            </div>
              <div className="diet-type-card-section">
                {dietTypes.map((yoga, index) => (
                    <div
                    key={index}
                    className="physio-type-card"
                    >
                    <img src={yoga.image} alt={yoga.name} className="leadership-image" />
                    <div className="physio-types-desc">
                    <h3 className="solutiontext"><span className="solutionbold">{yoga.name.split(" ")[0]}</span>{" "}
                    {yoga.name.split(" ").slice(1).join(" ")}</h3>
                    <p className="yoga-type-desc">{yoga.desc}</p>
                    </div>
                    </div>
                ))}
              </div>
              <div className="service-section-button">
                <button className="buttonlanding" onClick={()=>setIsOpen(true)}>Request a Call Back</button>
              </div>
            </section>
            
      <section>
        <div className="physio-options">
          <div className="physio-options-container">
            <h2 className="heading1-left">
            Transform your Eating Habits with Bridge Health’s
              <span className="highlight1"> Proven Dietary Approach</span>
              <span className="line-break-heading"></span>
            </h2>
            <p>Transform your eating habits with Bridge Health’s expert dietary approach. Our proven methods ensure personalized nutrition plans tailored to your goals. Achieve a healthier lifestyle with guidance you can trust.</p>
            
            <button className="buttonmaphome" onClick={()=>setIsOpen(true)}>Request a Call Back</button>

          </div>
          <div className="physio-option-right">
            <div className="accordion-container">
                {options.map((option, index) => (
                    <div key={index} className="accordion-item">
                    <button
                        className={`accordion-title-new ${activeIndex === index ? "active" : ""}`}
                        onClick={() => toggleAccordion(index)}
                    >
                        {option.title}
                        <span className={`chevron-icon ${activeIndex === index ? "rotate" : ""}`}>
                          {activeIndex === index ? "▲" : "▼"}
                        </span>
                    </button>
                    {activeIndex === index && (
                        <div className="accordion-content-desc">
                        {option.content}
                        </div>
                    )}
                    </div>
                ))}
            </div>
          </div>
        </div>
      </section>

      <section>
          <div className="expert-nutrition-container">
              {/* Left Column - Image */}
              <div className="expert-nutrition-left">
                <img
                  src="/images/new-website/diet-nutrition/nutrition-expert.webp"
                  alt="Health Journey"
                  className="expert-nutrition-image"
                />
              </div>

              {/* Right Column - Text */}
              <div className="expert-nutrition-right">
                <h1 className="heading1-left">
                Achieve Your Wellness Goals with Bridge Health’s {" "}
                  <span className="highlight1">
                  Expert Nutrition Programs
                  </span>{" "}
                </h1>
                <ul class="nutrition-list">
                    <li>Get Access to Personalised Diet Plans Backed by Nutrition Insights </li>
                    <li>Stay ahead of your health with cutting-edge technology AI-Enabled CGM (Continuous Glucose Monitoring) </li>
                    <li>Work with professional, highly experienced dieticians in JP Nagar in Bangalore for the best results </li>
                    <li>Achieve your ideal weight with science-backed strategies & effective weight-gain and weight-loss solutions </li>
                    <li>Our holistic programs help you feel calmer, sleep better, and reduce your stress</li>
                    <li>Build sustainable habits and enjoy a vibrant, energised version of yourself </li>
                </ul>
                <div style={{marginTop: "30px"}} className="button-container">
                  <button className="buttonjourney" onClick={()=>setIsOpen(true)}>Reach out to us today</button>
                </div>
              </div>
            </div>
        </section>

        <section className="why-choose-section-physio">
          <h2 className="heading1">Why Choose <span className="highlight1">Bridge Health</span> for Diet & Nutrition</h2>
                    
          <WhyLab
            whyData={whyData} 
            dynamicText="Radiology" 
            dynamicParagraph="We have some of the best specialists who bring years of experience and offer evidence – based treatment to ensure best care for you" 
          />
      </section>

    <section>
        <div>
        <FAQComponent faqs={faqs} />
        </div>
    </section>

    <section>
    <div className="testimonials-container">
      {/* Left Side */}
      <div className="left-section-testimonial">
        <h2>
        Trust Us Based on What Our <span className="highlight1">Patrons Say</span>
        </h2>
        <h3>Overall Ratings</h3>
        <div className="ratings">
          <img
            src="/images/new-website/women-care/google-logo-1.webp"
            alt="Google Logo"
          />
          <div>
            <p>
              4.9{" "}
              <span className="stars">
                ⭐⭐⭐⭐⭐
              </span>
            </p>
            <p>Customer Reviews</p>
          </div>
        </div>
        <a href="https://g.page/r/CagLkxSu4CfZEBM/review" target="_blank" rel="noopener noreferrer">
        <button className="buttonmaphome-review">Write a Review</button>
        </a>
      </div>

      {/* Right Side */}
      <div className="right-section-testimonial">
        <div className="testimonial-page">
      <TestimonialSlider testimonials={testimonials} />
    </div>
      </div>
    </div>
    </section>
    <Popup_Main isOpen={isOpen} onClose={() => setIsOpen(false)} >
        <ReachToUsForm submitted={() => setIsOpen(false)} />
        </Popup_Main>
        <Footer />
    </div>
  );
};

export default YogaPage;
